import React from 'react';

interface IFlexBetweenProps {
    children?: React.ReactNode[];
}

export const FlexBetween: React.FC<IFlexBetweenProps> = ({ children }) => {
    return <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '3rem', width: '100%' }}>{children}</div>;
};
